import { useState } from "react";
import { BreadCrumb, Title } from "@funcional/react-ui";
import { IGraphQLError } from "@common/contracts";
import { useHistory, useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import { ReadAndEditFinancialRefundForm } from "../components";
import { checkFields, getCachedIndustryData } from "../helpers";
import { IOptionsData } from "../contracts";

interface IParamsData {
    industryName?: string;
    action?: 'read' | 'edit';
};

export function ReadAndEditIndustryRulesPage() {
    const paramsData: IParamsData = useParams();
    const industryName = paramsData?.industryName;
    const action = paramsData?.action;
    const readonly = action === 'read' ? true : false;
    const queryClient = useQueryClient();
    const defaultData = getCachedIndustryData(industryName || "", queryClient);
    const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
    const history = useHistory();
    const breadCrumbLabel = readonly ? "Visualização" : "Edição";
    const industryNames = [{ view: industryName || "", value: defaultData.industryId }];
    const closureTypes = [{ view: "Mensal", value: "MONTHLY" }, { view: "Quinzenal", value: "FORTWEEKLY" }];
    const retailChains = [{ view: "DPSP", value: '1' }, { view: "PANVEL", value: '2' }, { view: "RAIA DROGASIL", value: '3' }]; //Pegar da query de bandeiras
    const optionsData: IOptionsData = {
        industryNames,
        closureTypes,
        retailChains,
    };

    const onSubmit = async (input: any): Promise<void> => {
        try {
            checkFields(input);
            alert("Configuração de ressarcimento financeiro concluída com sucesso!");
            history.push(`/refund/financial-reimbursement`);
        } catch (error: any) {
            alert("Ocorreu um erro!");
            if (error?.response?.errors) {
                return setGraphQLErrors(error.response.errors || []);
            }
            setGraphQLErrors([{
                message:
                    "Não foi possível salvar o registro, tente novamente mais tarde.",
            },
            ]);
        }
    };

    return (
        <>
            <Title>Configuração do Ressarcimento Financeiro - {industryName}</Title>
            <BreadCrumb
                items={[
                    { path: "/refund/financial-reimbursement", label: "Configuração do Ressarcimento Financeiro" },
                    { label: breadCrumbLabel },
                    { label: industryName || "" },
                ]} />
            <ReadAndEditFinancialRefundForm
                onSubmit={onSubmit}
                readonly={readonly}
                defaultData={defaultData || {}}
                optionsData={optionsData || {}} />
        </>
    )
}
